import Accordion from 'react-bootstrap/Accordion'

export default function DebugAccordion(props) {
    // return immediately unless we have debug enabled either via the props or from localStorage
    if(!props.data) return null
    const isDebug = localStorage.debug === 'true'
    if(!props.debug && !isDebug) return null
    const items = props.data.map(d => {
        return (
            <Accordion.Item eventKey={d.name} key={d.name}>
                <Accordion.Header>{d.name}</Accordion.Header>
                <Accordion.Body>
                    <pre>{JSON.stringify(d.data, null, 2)}</pre>
                </Accordion.Body>
            </Accordion.Item>
        )
    })

    return (
        <Accordion className="my-5" alwaysOpen>
            {items}
        </Accordion>
    )
}